<div class="content-wrapper">
  @if (characteristics()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle kenmerken <span>({{ totalCharacteristics() }})</span>
        </h2>
        <div class="search">
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label>Zoeken</mat-label>
            <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
            <button
              mat-icon-button
              matSuffix
              aria-label="Zoekopdracht wissen"
              (click)="clearSearch(); $event.stopPropagation()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <mat-table mat-table #table [dataSource]="filteredCharacteristics()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Kenmerk</mat-header-cell>
          <mat-cell *matCellDef="let characteristic">
            @if (characteristic.name) {
              <p class="text-truncate">
                {{ characteristic.name }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>Omschrijving</mat-header-cell>
          <mat-cell *matCellDef="let characteristic">
            @if (characteristic.description) {
              <p class="text-truncate">
                {{ characteristic.description }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let characteristic">
            <div class="buttons">
              <button mat-icon-button aria-label="Kenmerk bewerken">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          [ngClass]="{ 'row-inactive': !characteristic.active }"
          *matRowDef="let characteristic; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Kenmerk openen"
          (click)="editItem(characteristic)"
          (keydown.enter)="editItem(characteristic)"
          (keydown.space)="$event.preventDefault(); editItem(characteristic)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
